import {
  GraphDataQualityWarning,
  VizPortalDQWDataCatalogProvider, VizPortalDQWDataCatalogProviderProps, WarningStatusChip, WarningStatusProps
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Query } from 'react-apollo';

import {
  MetricUpstreamDataQualityWarningsQuery,
  MetricUpstreamDataQualityWarningsQueryVariables
} from '../../../gen-src/queries/MetricUpstreamDataQualityWarningsQuery';
import {
  MetricUpstreamDataQualityWarningsQueryGql
} from '../../queries/MetricUpstreamDataQualityWarningsQueryGql';
import { ErrorListProvider } from '../error/components/ErrorListProvider';
import { renderQueryResult } from '../renderQueryResult';

declare type DataQualityDetailPanelSide = 'left' | 'right';

interface MetricWarningProps {
  readonly metricLuid: string;
  readonly side: DataQualityDetailPanelSide;
}

export type EmbeddableMetricDataQualityWarningProps = VizPortalDQWDataCatalogProviderProps & MetricWarningProps;

export function EmbeddableMetricDataQualityWarning(props: EmbeddableMetricDataQualityWarningProps): JSX.Element {
  const { featureFlags: { publishedConnectionsLineageEnabled }, siteUrls: urls } = props;

  return (
    <VizPortalDQWDataCatalogProvider {...props}>
      <ErrorListProvider>
        <Query<MetricUpstreamDataQualityWarningsQuery, MetricUpstreamDataQualityWarningsQueryVariables>
          query={MetricUpstreamDataQualityWarningsQueryGql}
          variables={{ metricLuid: props.metricLuid, first: 10, offset: 0, publishedConnectionsLineageEnabled }}
        >
          {result => renderQueryResult(result, {
            renderLoading: () => renderWarnings(urls, props.side, undefined),
            renderData: data => renderWarnings(urls, props.side, data),
          })}
        </Query>
      </ErrorListProvider>
    </VizPortalDQWDataCatalogProvider>
  );
}

const empty: GraphDataQualityWarning[] = [];

export function renderWarnings(
  urls: SiteUrls,
  side: DataQualityDetailPanelSide,
  data?: MetricUpstreamDataQualityWarningsQuery
): JSX.Element | null {
  const metric = data && data.metrics ? data.metrics[0] : null;
  if (!metric) {
    return null;
  }

  const props: WarningStatusProps = {
    subjectArea: 'Metric',
    kind: 'graph',
    anchoredAsset: null,
    anchoredWarnings: [],
    iconOnly: false,
    side: side,
    urls,
    upstreamWarnings: metric.upstreamDataQualityWarningsConnection?.nodes ?? empty,
  }

  return <WarningStatusChip {...props} />;
}
